<template>
  <div>
    <form
      @submit.prevent="do_submit"
      ref="contact_form"
      :class="form_class"
      v-if="contact_form_status == 0"
    >
      <h1 class="text-main-color uppercase font-bold mb-8 text-center">
        Contact Us
      </h1>
      <div class="block text-gray-700 text-sm">
        For answers to your questions, please click on the topic below to be
        directed to the applicable department:
        <ul class="form-option-list list-disc ml-10">
          <li>
            <a
              href="https://www.fresenius-kabi.com/us/report-an-adverse-drug-event"
              target="_blank"
              >Report an Adverse Drug Event</a
            >
          </li>
          <li>
            <a
              href="https://www.fresenius-kabi.com/us/submit-a-medical-inquiry"
              target="_blank"
              >Submit a Medical Inquiry</a
            >
          </li>
          <li>
            <a
              href="https://www.fresenius-kabi.com/us/contact-pharmaceutical-customer-service"
              target="_blank"
              >Contact Customer Service</a
            >
          </li>
          <li>
            Additional options available by visiting
            <a
              href="https://www.fresenius-kabi.com/us/get-answers"
              target="_blank"
              >Fresenius Kabi Get Answers</a
            >
          </li>
        </ul>
      </div>

      <div class="block text-gray-700 text-sm py-4">
        To be contacted by a <strong>sales representative</strong>, please
        complete the form below. Please expect a response within 2 business
        days.
      </div>

      <div class="md:grid md:grid-cols-2 md:gap-3 mt-3">
        <template v-for="item in form_model">
          <SimpleTextField
            :id="item.id"
            :label="item.label"
            v-model="item.value"
            :extra_field_class="item.extra_class"
            :type="item.type"
            v-if="item.type == 'text'"
            :key="item.id"
            :required="item.required"
          />
          <SimpleTextArea
            :id="item.id"
            :label="item.label"
            v-model="item.value"
            :extra_field_class="item.extra_class"
            :type="item.type"
            v-if="item.type == 'textarea'"
            :key="item.id"
            :required="item.required"
          />
          <SimpleSelectBox
            :id="item.id"
            :label="item.label"
            v-model="item.value"
            :extra_field_class="item.extra_class"
            :type="item.type"
            :options="item.options"
            v-if="item.type == 'selectbox'"
            :key="item.id"
            :required="item.required"
          />
          <HiddenField
            :id="item.id"
            v-model="item.value"
            v-if="item.type == 'hidden'"
            :key="item.id"
          />
        </template>
      </div>

      <div class="mt-3">
        <template v-for="item in form_model">
          <div :key="item.id" v-if="item.type == 'checkboxgroup'">
            <div class="mt-4">
              <label class="block text-gray-700 text-sm font-bold mb-0 sm:mb-2"
                ><span :class="item.extra_class"
                  >{{ item.label }} *</span
                ></label
              >
            </div>
            <div class="grid grid-cols-1">
              <label
                v-for="checkbox_option in item.options"
                class="block text-sm mb-1"
              >
                <input
                  v-model="item.value"
                  :name="item.id + '[]'"
                  type="checkbox"
                  :value="checkbox_option[0]"
                />&nbsp;&nbsp;{{ checkbox_option[1] }}
              </label>
            </div>
          </div>
        </template>
      </div>

      <div class="text-xs pt-4 text-justify">
        By submitting this request, you are opting in to receive emails from
        Fresenius Kabi. This will allow for us to digitally communicate with you
        via emails, which might contain newsletters, product information and
        updates. You may withdraw your consent at any time by clicking the
        "unsubscribe" link in our emails.
      </div>

      <div class="flex items-center justify-center mt-4">
        <button
          class="bg-default-btn-color hover:bg-default-btn-color-hover text-white font-bold py-2 px-12 rounded focus:outline-none focus:shadow-outline"
          type="submit"
        >
          Submit
        </button>
      </div>
    </form>
    <div
      class="max-h-screen py-24 text-center border-white border-2"
      v-if="contact_form_status == 1"
    >
      <img src="../../assets/loading.svg" class="mx-auto" />
    </div>
    <div class="success py-40 text-center" v-if="contact_form_status == 2">
      <strong>Thank you!</strong><br /><br />
      Your info has been routed to one of our specialists who will be getting
      back to you shortly.
    </div>
    <div class="error py-40 text-center" v-if="contact_form_status == 3">
      <strong class="text-red-500">Sorry, there was an error!</strong
      ><br /><br />
      The form could not be submitted. Please try again.
    </div>
  </div>
</template>
<script>
import SimpleTextField from "../form/SimpleTextField";
import SimpleTextArea from "../form/SimpleTextArea";
import SimpleSelectBox from "../form/SimpleSelectBox";
import HiddenField from "../form/HiddenField";
import { mapState, mapGetters } from "vuex";

export default {
  name: "ContactForm",
  components: {
    SimpleTextField,
    HiddenField,
    SimpleTextArea,
    SimpleSelectBox
  },
  data() {
    return {
      form_class: "contact_form_page",
      timer: null,

      form_model: [
        {
          id: "name",
          type: "text",
          required: true,
          label: "First Name",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "last_name",
          type: "text",
          required: true,
          label: "Last Name",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "company",
          type: "text",
          required: true,
          label: "Company",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "email",
          type: "text",
          required: true,
          label: "Email",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },

        {
          id: "state",
          type: "text",
          required: true,
          label: "State",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },

        {
          id: "zip",
          type: "text",
          required: true,
          label: "Zip Code",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "phone",
          type: "text",
          required: false,
          label: "Phone",
          value: "",
          extra_class: "",
          validation: []
        },

        {
          id: "interested",
          type: "checkboxgroup",
          required: true,
          label: "Tell us more about what you're looking for. ",
          value: [],
          extra_class: "",
          validation: ["notempty_array"],
          options: [
            [
              "Information on Infusion Delivery Solutions",
              "Information on Infusion Delivery Solutions"
            ],
            [
              "Information on Simplist and Simplist MicroVault Products",
              "Information on Simplist® and Simplist® MicroVault™ Products"
            ],
            [
              "Information on other Fresenius Kabi products",
              "Information on other Fresenius Kabi products"
            ],
            [
              "Information on ISMP Safety Guideline Resources",
              "Information on ISMP Safety Guideline Resources"
            ]
          ]
        },
        {
          id: "event_tag",
          type: "hidden",
          required: false,
          label: "Event Tag",
          value: "",
          extra_class: "",
          validation: []
        }
      ]
    };
  },
  computed: {
    ...mapState(["site_config", "contact_form_status"]),
    ...mapGetters(["eventTag"])
  },

  methods: {
    do_submit(app_mode) {
      let formData = new FormData();

      let valid_form = true;

      this.form_model.forEach((item) => {
        let valid_field = true;
        let validation = item.validation;
        let error_class = "border-red-500";
        validation.forEach((validation_type) => {
          switch (validation_type) {
            case "notempty":
              if (item.value.length <= 0) {
                valid_form = false;
                valid_field = false;
                error_class = "border-red-500";
              }

              break;
            case "notempty_array":
              if (item.value.length <= 0) {
                valid_form = false;
                valid_field = false;
                error_class = "text-red-500";
              }
              break;
          }
        });
        if (valid_field) {
          item.extra_class = "";
        } else {
          item.extra_class = error_class;
        }
      });

      //for debugging purposes, allow the form to always be valid
      //so we don't need to fill it in all the time
      if (!this.site_config.validate_form) {
        valid_form = true;
      }

      if (!valid_form) {
        return;
      }

      var data_to_submit = new FormData();

      this.form_model.forEach((item) => {
        data_to_submit.append(item.id, item.value);
      });

      this.$store.dispatch("submit_contact_form", data_to_submit);

      this.$refs.contact_form.reset();

      this.$ga.event(this.eventTag + "contact_form", "submit", "submit", 1);
    },
    reset_form() {
      this.$store.dispatch("set_contact_form_status", 0);
    }
  },
  mounted() {
    this.form_model.forEach((item) => {
      if (item.id == "event_tag") {
        item.value = this.eventTag;
      }
    });
  },
  watch: {
    contact_form_status(val) {
      switch (val) {
        case 2:
        case 3:
          this.timer = setTimeout(this.reset_form.bind(this), 4000);
          break;
      }
    }
  }
};
</script>
<style scoped>
.hidden-fields {
  height: 0;
  opacity: 0;
  transition: all 0.1s;
  overflow: hidden;
}
.hidden-fields.active {
  opacity: 1;
  height: auto;
}
.form-option-list {
  margin-top: 9px;
}
.form-option-list li {
  margin-bottom: 6px;
}
.form-option-list a {
  color: #2b6cb0;
}
</style>
<style>
@media only screen and (min-width: 640px) {
  .contact_form_page .simple-field-container {
    margin-bottom: 3px;
  }

  .contact_form_page .simple-field-container label {
    margin-bottom: 1.7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/ContactFormPage.vue